// Breakpoint utility for responsive design
const breakpoint = {
    breakpoints: {
        phone: 1,
        tablet: 600,
        tabletLandscape: 1024,
        desktop: 1132
    },

    getActive() {
        const width = window.innerWidth;
        if (width < this.breakpoints.tablet) return 'phone';
        if (width < this.breakpoints.tabletLandscape) return 'tablet';
        if (width < this.breakpoints.desktop) return 'tabletLandscape';
        return 'desktop';
    },

    isPhone() {
        return this.getActive() === 'phone';
    },

    isTablet() {
        return this.getActive() === 'tablet';
    },

    isTabletLandscape() {
        return this.getActive() === 'tabletLandscape';
    },

    isDesktop() {
        return this.getActive() === 'desktop';
    }
};

// Make it globally available as 'im' for backward compatibility
if (typeof window !== 'undefined') {
    window.im = breakpoint;
}

export default breakpoint;
